exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TitleBar {\n  display: flow-root;\n  height: 74px;\n  padding: 14px 36px 20px 36px;\n}\n\n.TitleBar svg {\n  background-color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n  fill: #bac2c7;\n  float: left;\n  margin: 6px 7px 0 0;\n}\n\n.TitleBar h1 {\n  color: #777;\n  float: left;\n  font-size: 32px;\n  font-weight: 400;\n  line-height: 38px;\n}\n", ""]);

// exports
